import { MainLayout } from '@/components/layouts/MainLayout'
import { Card } from '@/components/ui/Card'
import { EditableContent } from '@/components/EditableContent'
import { ShopBalance, ShopAccessButton, CreditHistory } from '@/components/shop'
import { Gift, AlertCircle } from 'lucide-react'
import type { ShopPageProps } from '@/types'

interface Props extends ShopPageProps {}

export default function Shop({ balance, credit_history, error, editable_banner }: Props) {
  return (
    <MainLayout title="Ma Boutique">
      {/* Banner éditable (si existe) */}
      {editable_banner && (
        <EditableContent
          content={editable_banner}
          wrapperClassName="mb-8 -mt-8 -mx-4"
        />
      )}

      <div className="space-y-8">
        {/* Header */}
        <div className="bg-gradient-to-r from-tessan-green to-tessan-green/90 rounded-xl p-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-white/20 rounded-xl">
              <Gift size={32} className="!text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-display font-bold !text-white">
                Ma boutique de récompenses
              </h1>
              <p className="!text-white/80">
                Utilisez vos crédits pour obtenir des cadeaux exclusifs !
              </p>
            </div>
          </div>
        </div>

        {/* Error message */}
        {error && (
          <Card className="bg-red-50 border-red-200">
            <div className="flex items-center gap-3 text-red-700">
              <AlertCircle size={20} />
              <p>{error}</p>
            </div>
          </Card>
        )}

        {/* Balance */}
        <ShopBalance balance={balance} />

        {/* Access button */}
        <ShopAccessButton />

        {/* Credit history */}
        <CreditHistory history={credit_history} />
      </div>
    </MainLayout>
  )
}
